import commonObj from "../../../../services/common.js";
import { HTTP } from "../../../../services/api-service.js";
var common = new commonObj();
var baseUrl = common.baseURL;
var tableName = 'MMBundle';

const bundleStore = {
    namespaced: true,
    state:{
        totalItem:0,
        q : {
            tableNeedQuery: tableName,
            isOuterJoin: false,       
            searchCriteria: "",
            orderBy: "BdlID,asc",
            take: 1000000,
            skip: 0
        },
        currentSelectedPage: 0,
    },
    actions:{
        getAllBundle({commit,state},param) {
            return new Promise((resolve, reject) => {
                HTTP.post(baseUrl + '/qgl/listvalue', state.q).then(response => {
                    resolve(response);
                })
                .catch(e => {
                    reject(e);
                });
            });
        },
        saveBundle({ commit }, param) {
            return new Promise((resolve, reject) => {
                HTTP.post(
                baseUrl + "/mm/save",
                JSON.stringify({
                    type: tableName,
                    modelList: param.bundleModel,
                    option: param.option
                })
                )
                .then(response => {
                    resolve(response);
                })
                .catch(e => {
                    reject(e);
                });
            });
        },
        exportFile({ commit, state }, param) {
            return new Promise((resolve, reject) => {
                HTTP.post(baseUrl + "/mm/export", state.q, { responseType: "blob" })
                .then(response => {
                    resolve(response);
                })
                .catch(e => {
                    reject(e);
                });
            });
        }
    }
};
export default bundleStore;